// extracted by mini-css-extract-plugin
module.exports = {"table":"performance_table__iCKoL","tableGroup":"performance_tableGroup__3uOWG","chartGrid":"performance_chartGrid__z5alO"};